import { Database } from "@revelate/types";

export const getTeamInitials = (
  team: Database["public"]["Tables"]["teams"]["Row"] | null
) => {
  return team?.name.slice(0, 2).toUpperCase() || "";
};
